import { Controller } from "@hotwired/stimulus";

const MOBILE_BREAKPOINT = 800;
const LOCKED_DIALOG_CLASS = "dialog__container--profile-completion-locked";
const PREV_CLOSEDBY_DATA_KEY = "profileCompletionPreviousClosedby";
const NO_PREVIOUS_CLOSEDBY = "__none__";
const DIALOG_FRAME_ID = "dialog_modal";

export default class extends Controller {
  static targets = ["trigger"];

  connect() {
    this.handleResize = this.handleResize.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.resizeRaf = null;

    window.addEventListener("resize", this.handleResize);
    window.addEventListener("turbo:before-cache", this.handleDialogClose);

    const dialog = this.findDialog();
    dialog?.addEventListener("close", this.handleDialogClose);

    // Automatically click the hidden trigger link to open dialog
    requestAnimationFrame(() => {
      if (this.hasTriggerTarget) {
        this.syncDialogLockState();
        this.triggerTarget.click();
      }
    });
  }

  disconnect() {
    if (this.resizeRaf) {
      cancelAnimationFrame(this.resizeRaf);
      this.resizeRaf = null;
    }

    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("turbo:before-cache", this.handleDialogClose);

    const dialog = this.findDialog();
    dialog?.removeEventListener("close", this.handleDialogClose);
    if (dialog) {
      this.unlockDialog(dialog);
    }
  }

  handleResize() {
    if (this.resizeRaf) return;

    this.resizeRaf = requestAnimationFrame(() => {
      this.resizeRaf = null;
      this.syncDialogLockState();
    });
  }

  handleDialogClose() {
    const dialog = this.findDialog();
    if (!dialog) return;

    this.unlockDialog(dialog);
  }

  syncDialogLockState() {
    const dialog = this.findDialog();
    if (!dialog) return;

    if (window.innerWidth < MOBILE_BREAKPOINT) {
      this.lockDialog(dialog);
    } else {
      this.unlockDialog(dialog);
    }
  }

  findDialog() {
    const dialogFrame = document.getElementById(DIALOG_FRAME_ID);
    return (
      dialogFrame?.closest("dialog[data-dialog-target='modal']") ||
      document.querySelector("dialog[data-dialog-target='modal']")
    );
  }

  lockDialog(dialog) {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;

    if (!dialog.dataset[PREV_CLOSEDBY_DATA_KEY]) {
      dialog.dataset[PREV_CLOSEDBY_DATA_KEY] =
        dialog.getAttribute("closedby") ?? NO_PREVIOUS_CLOSEDBY;
    }

    dialog.classList.add(LOCKED_DIALOG_CLASS);
    dialog.setAttribute("closedby", "none");
  }

  unlockDialog(dialog) {
    const previousClosedBy = dialog.dataset[PREV_CLOSEDBY_DATA_KEY];
    if (previousClosedBy === undefined) return;

    dialog.classList.remove(LOCKED_DIALOG_CLASS);
    delete dialog.dataset[PREV_CLOSEDBY_DATA_KEY];

    if (!previousClosedBy || previousClosedBy === NO_PREVIOUS_CLOSEDBY) {
      dialog.removeAttribute("closedby");
      return;
    }

    dialog.setAttribute("closedby", previousClosedBy);
  }
}
